var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailCampaignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#3829E0",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9639 16.4283L17.7805 20.3067C18.583 20.8408 18.9839 21.1083 19.4172 21.2125C19.8005 21.3042 20.1997 21.3042 20.5822 21.2125C21.0155 21.1083 21.4164 20.8408 22.2189 20.3067L28.0355 16.4283M15.9639 26.25H24.0355C25.4355 26.25 26.1355 26.25 26.6705 25.9775C27.1406 25.7377 27.5227 25.3553 27.7622 24.885C28.0355 24.35 28.0355 23.65 28.0355 22.25V17.75C28.0355 16.35 28.0355 15.65 27.763 15.115C27.5234 14.6446 27.1409 14.2622 26.6705 14.0225C26.1355 13.75 25.4355 13.75 24.0355 13.75H15.9639C14.5639 13.75 13.8639 13.75 13.3289 14.0225C12.8588 14.2623 12.4767 14.6447 12.2372 15.115C11.9639 15.65 11.9639 16.35 11.9639 17.75V22.25C11.9639 23.65 11.9639 24.35 12.2364 24.885C12.476 25.3554 12.8585 25.7378 13.3289 25.9775C13.8639 26.25 14.5639 26.25 15.9639 26.25Z",
    stroke: "#534BDB",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCampaignIcon);
export default __webpack_public_path__ + "static/media/Email-campaign-icon.2512d7fe17bdd644cc7b2ab433bf08c3.svg";
export { ForwardRef as ReactComponent };